import React, {useEffect} from "react";
import {SearchContactsInner} from "../../../../../components/common/modal/inner/SearchContactsInner";
import {useModal} from "../../../../../hooks";
import SearchAddressInner from "../../../../../components/common/modal/inner/SearchAddressInner";
import {UseFormRegister, UseFormSetValue, UseFormWatch} from "react-hook-form";
import {OrdersCreateType} from "../interface";
import {useReadShippingSelectBox} from "../hooks/useReadShippingSelectBox";
import {useReadPaymentSelectBox} from "../hooks/useReadPaymentSelectBox";
import {useUser} from "../../../../../util/userContext/UserContext";
import {SearchErpInner} from "../../../../../components/common/modal/inner/SearchErpInner";
import {SearchBusinessPartnerInner} from "../../../../../components/common/modal/inner/SearchBusinessPartnerInner";
import {useReadIndustrySelectBox, useReadOrderTypeSelectBox} from "../../../../customer/correspondent/detail/hooks";
import useReadVatSelectBox from "../../../../customer/correspondent/detail/hooks/useReadVatSelectBox";
import useReadApplicationSelectBox from "../../../../customer/correspondent/detail/hooks/useReadApplicationSelectBox";
import {SearchSystemUserInner} from "../../../../../components/common/modal/inner/SearchSystemUserInner";
import useSetOrdersValue from "../hooks/useSetOrdersValue";
import moment from "moment";

interface PropsType {
    watchCreateDetail: OrdersCreateType
    register: UseFormRegister<OrdersCreateType>
    setValue: UseFormSetValue<OrdersCreateType>
    watch: UseFormWatch<OrdersCreateType>
}

export default function Tab1({watchCreateDetail, register, setValue, watch}: PropsType) {
    const {handleModal} = useModal();
    const {user} = useUser();

    const {data: shipmentList} = useReadShippingSelectBox()
    const {data: paymentList} = useReadPaymentSelectBox()
    const {data: orderTypeList} = useReadOrderTypeSelectBox();
    const {data: vatList} = useReadVatSelectBox();
    const {data: industryList} = useReadIndustrySelectBox();
    const {data: applicationList} = useReadApplicationSelectBox();

    useEffect(() => {
        if (paymentList) {
            const value = paymentList.find((el: any) => el.name.includes("현금"))?.id

            setValue("newPPayment", value)
        }
    }, [paymentList]);

    const {setContact, setAccount} = useSetOrdersValue()

    // NOTE: 수신자(_new_l_recipient_value), 계산서담당자(newLInvoiceAgentValue), 수주고객(newLContactValue) 선택 모달
    const btnSearchRecipient = (key: "_new_l_recipient_value" | "newLInvoiceAgentValue" | "newLContactValue") => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchContactsInner
                    confirmCallback={(item) => {
                        setValue(key, item.contactId)

                        if (key === "_new_l_recipient_value") {
                            setValue("recipientName", item.fullName ?? "")
                            setValue("recipientMobilephone", item.mobilePhone ?? "")
                        } else if (key === "newLInvoiceAgentValue") {
                            setValue("taxCharge", item.fullName ?? "")
                            setValue("taxContact", item.mobilePhone ?? "")
                            setValue("taxEmail", item.emailAddress1 ?? "")
                        } else if (key === "newLContactValue") {
                            setContact(item, setValue)
                        }
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: "연락처 조회",
            modalSize: "xxl",
        })
    }

    // NOTE: 발송지 선택 모달
    const btnSearchAddress = () => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchAddressInner
                    confirmCallback={(item) => {
                        setValue("_new_l_address_value", item?.new_addressid ?? "")
                        setValue("address1", item?.new_txt_line1 ?? "")
                        setValue("address2", item?.new_txt_line2 ?? "")
                        setValue("addressName", item?.newName ?? "")
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: "발송지 조회",
            modalSize: "xxl",
        })
    }

    // NOTE: 담당자 선택 모달
    const btnSearchUser = () => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchSystemUserInner
                    confirmCallback={(item) => {
                        setValue("owneridValue", item.systemuserid ?? "")
                        setValue("owningUserName", item.fullname ?? "")
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: "담당자 조회",
            modalSize: "xl",
        })
    }

    // NOTE: 납품처 선택 모달
    const btnSearchErp = (key: "newLShipToValue" | "newLCustomerValue") => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchErpInner
                    confirmCallback={(item) => {
                        setValue(key, item.new_erp_accountid ?? "")

                        if (key === "newLShipToValue") {
                            setValue("shipToName", item.new_txt_nm_partner ?? "")
                        } else if (key === "newLCustomerValue") {
                            setValue("customerName", item.new_txt_nm_partner ?? "")
                        }
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: key === "newLShipToValue" ? "납품처 조회" : "매출처 조회",
            modalSize: "xl",
        })
    }

    // NOTE: 고객사 선택 모달
    const btnSearchAccount = () => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchBusinessPartnerInner
                    confirmCallback={(item) => {
                        setAccount(item, setValue)
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: "고객사 조회",
            modalSize: "xxl",
        })
    }

    return <div className="content_wrap">
        <div className="table_scroll">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>고객사 <span className="required">*</span></th>
                    <td style={{width: "33.34%"}} className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.enduserName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={btnSearchAccount}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>수주고객 <span className="required">*</span></th>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.contactName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnSearchRecipient("newLContactValue")}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>담당자 <span className="required">*</span></th>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.owningUserName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={btnSearchUser}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                    <th>요청자 <span className="required">*</span></th>
                    <td>{user?.userName}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div className="table_scroll">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>발송요청일</th>
                    <td style={{width: "33.34%"}} className="p-4px">
                        <input type="date"
                               className="form-control"
                               max="9999-12-31 23:59"
                               value={watchCreateDetail.newDtRequestShipment}
                               {...register("newDtRequestShipment")}/>
                    </td>
                    <th style={{width: "16.66%"}}>발송방법 <span className="required">*</span></th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail.newPShipment}
                                {...register("newPShipment")}>
                            <option value={0}>선택</option>
                            {shipmentList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>수신자 <span className="required">*</span></th>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.recipientName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnSearchRecipient("_new_l_recipient_value")}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                    <th>연락처</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.recipientMobilephone}
                               disabled/>
                    </td>
                </tr>
                <tr>
                    <th>발송지</th>
                    <td className="p-4px" colSpan={3}>
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.addressName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={btnSearchAddress}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>주소1</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.address1}
                               disabled/>
                    </td>
                    <th>주소2</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.address2}
                               disabled/>
                    </td>
                </tr>
                <tr>
                    <th>메모</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.newTxtMemo}
                               {...register("newTxtMemo")}/>
                    </td>
                    <th>기타사항(거래명세서 비고)</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.newTxtNote}
                               {...register("newTxtNote")}/>
                    </td>
                </tr>
                <tr>
                    <th>고객메모</th>
                    <td className="p-4px" colSpan={3}>
                        <input type="text" className="form-control"
                               value={watchCreateDetail.customerMemo}
                               {...register("customerMemo")}
                               disabled/>
                    </td>
                </tr>
                <tr>
                    <th>마감 구분</th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail.endType}
                                {...register("endType")}>
                            <option value={"1"}>일반</option>
                            <option value={"2"}>월마감</option>
                            <option value={"3"}>역발행</option>
                        </select>
                    </td>
                    <th>매출 구분</th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail.salesType}
                                {...register("salesType", {
                                    onChange: (e) => {
                                        const salesType = e.target.value;
                                        if (salesType === "1") setValue("newDtOrder", moment().format("YYYY-MM-DD"));
                                        else if (salesType === "2") setValue("newDtOrder", moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'));
                                    },
                                })}>
                            <option value={""} hidden>선택</option>
                            <option value={undefined} hidden>선택</option>
                            <option value={"1"}>당월</option>
                            <option value={"2"}>이월</option>
                        </select>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div className="table_scroll">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>납품처 <span className="required">*</span></th>
                    <td style={{width: "33.34%"}} className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.shipToName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnSearchErp("newLShipToValue")}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>매출처 <span className="required">*</span></th>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.customerName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnSearchErp("newLCustomerValue")}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>수주일자 <span className="required">*</span></th>
                    <td className="p-4px">
                        <input type="date"
                               className="form-control"
                               max="9999-12-31 23:59"
                               value={watchCreateDetail.newDtOrder}
                               {...register("newDtOrder")}/>
                    </td>
                    <th>출하일자</th>
                    <td className="p-4px">
                        <input type="date"
                               className="form-control"
                               max="9999-12-31 23:59"
                               value={watchCreateDetail.newDtShipment}
                               {...register("newDtShipment")}/>
                    </td>
                </tr>
                <tr>
                    <th>수주 유형 <span className="required">*</span></th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail._new_l_order_type_m_value}
                                {...register("_new_l_order_type_m_value")}>
                            <option value={""}>선택</option>
                            {orderTypeList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                        </select>
                    </td>
                    <th>Vat 구분 <span className="required">*</span></th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail._new_l_vat_value}
                                {...register("_new_l_vat_value")}>
                            <option value={""}>선택</option>
                            {vatList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>산업 구분 <span className="required">*</span></th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail.newLIndustryValue}
                                {...register("newLIndustryValue")}>
                            <option value={""}>선택</option>
                            {industryList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                        </select>
                    </td>
                    <th>Application <span className="required">*</span></th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail.newLApplicationValue}
                                {...register("newLApplicationValue")}>
                            <option value={""}>선택</option>
                            {applicationList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                        </select>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div className="table_scroll">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>수금예정일 <span className="required">*</span></th>
                    <td className="p-4px" style={{width: "33.34%"}}>
                        <input type="date"
                               className="form-control"
                               max="9999-12-31 23:59"
                               value={watchCreateDetail.newDtEstimatedCollection}
                               {...register("newDtEstimatedCollection")}/>
                    </td>
                    <th style={{width: "16.66%"}}>결제방법 <span className="required">*</span></th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail.newPPayment}
                                {...register("newPPayment")}>
                            <option value={0}>선택</option>
                            {paymentList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>수금메모(세금계산서 비고)</th>
                    <td className="p-4px" colSpan={3}>
                        <input type="text" className="form-control"
                               value={watchCreateDetail.newTxtCollection}
                               {...register("newTxtCollection")}/>
                    </td>
                </tr>
                <tr>
                    <th>계산서담당자 <span className="required">*</span></th>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.taxCharge}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnSearchRecipient("newLInvoiceAgentValue")}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                    <th>연락처</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.taxContact}
                               disabled/>
                    </td>
                </tr>
                <tr>
                    <th>이메일</th>
                    <td className="p-4px" colSpan={3}>
                        <input type="text" className="form-control"
                               value={watchCreateDetail.taxEmail}
                               disabled/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
}